import * as React from 'react';

import { cn } from '../../lib/utils';

export type TovShimmerProps<TElement extends React.ElementType = 'div'> =
  React.ComponentPropsWithoutRef<TElement> & {
    as?: TElement;
    height?: React.CSSProperties['height'];
    radius?: React.CSSProperties['borderRadius'];
    width?: React.CSSProperties['width'];
  };

export function TovShimmer<TElement extends React.ElementType = 'div'>({
  as,
  className,
  height,
  radius,
  style,
  width,
  ...props
}: TovShimmerProps<TElement>) {
  const Component = (as ?? 'div') as React.ElementType;
  const shimmerStyle = {
    ...style,
    '--tov-shimmer-height': height,
    '--tov-shimmer-radius': radius,
    '--tov-shimmer-width': width,
  } as React.CSSProperties;

  return (
    <Component
      aria-hidden="true"
      className={cn('tov-shimmer', className)}
      style={shimmerStyle}
      {...(props as React.ComponentPropsWithoutRef<TElement>)}
    />
  );
}
